import { useAppearance } from '@plug-core/state'
import { AppearanceTone } from '@plug-core/state/appearance'
import { RowTile, SegmentedControl, cn } from '@ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

const Swatch = ({ tone }: { tone: AppearanceTone }) => (
  <span
    aria-hidden="true"
    className={cn(
      'size-3.5 rounded-full border border-solid border-hairline-strong',
      tone === 'flux' ? 'bg-[image:var(--plug-grad-flux)]' : 'bg-[image:var(--plug-grad-night)]'
    )}
  />
)

/** Tone toggle: Dark (night, default) or Flux. Persisted in plug-core's appearance store. */
export const AppearanceRow = () => {
  const { t } = useTranslation()
  const tone = useAppearance((state) => state.tone)
  const setTone = useAppearance((state) => state.setTone)

  return (
    <div className="flex min-h-[60px] flex-wrap items-center gap-3 px-4 py-2.5">
      <RowTile>🎨</RowTile>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-[15px] leading-[1.3] font-semibold">
          {t('settings.appearance.primaryText')}
        </span>
        <span className="text-[13px] leading-[1.4] text-fg-2">
          {t('settings.appearance.secondaryText')}
        </span>
      </div>
      <SegmentedControl<AppearanceTone>
        aria-label={t('settings.appearance.primaryText')}
        size="sm"
        value={tone}
        onChange={setTone}
        options={[
          { value: 'night', label: t('settings.appearance.dark'), icon: <Swatch tone="night" /> },
          { value: 'flux', label: t('settings.appearance.flux'), icon: <Swatch tone="flux" /> },
        ]}
      />
    </div>
  )
}
